export interface UserPreference {
  id: string;
  key: string;
  value: string;
  canDelete: boolean;
}
